import { getOperationStatus } from '../services/OperationTimeService';

// KST 시간 계산 함수
export const getCurrentKSTTime = () => {
  const now = new Date();
  const kstTime = new Date(now.toLocaleString("en-US", {timeZone: "Asia/Seoul"}));
  return kstTime;
};

// 예약배달 가능 여부 판단 함수
export const isScheduledDeliveryAvailable = () => {
  const currentKST = getCurrentKSTTime();
  const currentHour = currentKST.getHours();
  return currentHour < 20; // 20시 이전에만 예약배달 가능
};

// 배달 상태 정보 타입
export interface DeliveryStatus {
  canOrderNow: boolean;
  canOrderLater: boolean;
}

// 배달 상태 판단 함수
export const getDeliveryStatus = async (): Promise<DeliveryStatus> => {
  try {
    const operationStatus = await getOperationStatus();
    const isOpen = operationStatus.isOpen;
    const canSchedule = isScheduledDeliveryAvailable();
    
    return {
      canOrderNow: isOpen,
      canOrderLater: canSchedule
    };
  } catch (error) {
    console.warn('[DeliveryUtils] Failed to get operation status:', error);
    // 에러 발생 시 기본값
    return {
      canOrderNow: false,
      canOrderLater: false
    };
  }
}; 